import { createElement, IconNode } from 'lucide';

const svgNs = 'http://www.w3.org/2000/svg';

export function encircle(iconNode: IconNode, circleAttrs: Record<string, string> = {}): string {
    const margin = 16;
    const size = 24;
    const icon = createElement(iconNode);
    icon.children
    let circle = document.createElementNS(svgNs, 'circle');
    circle.setAttribute('cx', `${size / 2 + margin}`);
    circle.setAttribute('cy', `${size / 2 + margin}`);
    circle.setAttribute('r', `${(size + margin) / 2}`);
    for (const [key, value] of Object.entries(circleAttrs)) {
        circle.setAttribute(key, value);
    }
    let svg = document.createElementNS(svgNs, 'svg');
    svg.setAttribute('xmlns', svgNs);
    let transform = document.createElementNS(svgNs, 'g');
    transform.setAttribute('transform', `translate(${margin}, ${margin})`);
    transform.setHTMLUnsafe(icon.innerHTML);
    svg.appendChild(circle);
    svg.appendChild(transform);
    svg.setAttribute('width', `${size + margin * 2}`);
    svg.setAttribute('height', `${size + margin * 2}`);
    svg.setAttribute('transform', 'scale(0.8, 0.8)');
    svg.setAttribute('fill', 'white');
    svg.setAttribute('stroke', 'black');
    svg.setAttribute('stroke-width', '2');
    return svg.outerHTML;
}